<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('guides_fees.admin_guides') }} {{ client_name }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">

                    <!-- Pickup Addresses -->
                    <v-form ref="form2" lazy-validation @submit.prevent="save">
                        
                        <v-row class="px-5 py-0 mt-2 mb-0" justify="center" align="center">
                            <v-col cols="10" class="py-0">
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        
                                        <v-expansion-panel-header>
                                            {{$t('guides_fees.pickup_addresses')}}
                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content class="mt-2">
                                            
                                            <v-row class="px-0 py-0 my-0" justify="end" align="end">
                                                <v-col cols="4" class="py-0" justify="end" align="end">
                                                    <v-btn class="right white_highlight--text" color="secondary" @click="modal_create = true">{{ $t('guides_fees.create_pickup_address') }}</v-btn>
                                                </v-col>
                                            </v-row>
                                            
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                                <v-col cols="12" class="py-0">
                                                    <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                                                </v-col>
                                            </v-row>

                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-form>

                    <!-- Settings -->
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                        
                        <v-row class="px-5 py-0 mt-2 mb-0" justify="center" align="center">
                            <v-col cols="10" class="py-0">
                                <v-expansion-panels>

                                    <!-- SHIPPING SERVICES -->
                                    <v-expansion-panel v-for="(item, i) in settings.fees" :key="i">
                                        <v-expansion-panel-header>
                                            {{$t('guides_fees.' + i)}}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="mt-2">
                                             <!-- GENERAL CONFIGURATION -->

                                            <v-row class="px-3 py-0 mt-0 mb-3" justify="center" align="center" v-if="i !== 'general_configuration'">
                                                <v-col cols="12" class="py-0 marker1-1 mx-0 px-0">
                                                    <label class="mx-0 px-1" style="font-weight: bolder;">{{ $t('guides_fees.fixed_fees') }}</label>
                                                </v-col>
                                            </v-row>

                                            <v-row class="px-0 py-0 my-0" justify="center" align="center" v-if="i == 'general_configuration'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings.fees[i].monthly_shipping_limit" :label="$t('guides_fees.guides_limit')"></v-text-field>
                                                </v-col>
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings.fees[i].unpaid_guides_limit" :label="$t('guides_fees.credit_limit')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center" v-if="i != 'general_configuration'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings.fees[i].extended_zone" :label="$t('guides_fees.extended_zone')"></v-text-field>
                                                </v-col>
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings.fees[i].address_correction" :label="$t('guides_fees.address_correction')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center" v-if="i != 'general_configuration'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings.fees[i].saturday_pickup" :label="$t('guides_fees.saturday_pickup')"></v-text-field>
                                                </v-col>
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings.fees[i].extra_large_package" :label="$t('guides_fees.extra_large_package')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center" v-if="i != 'general_configuration'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings.fees[i].kilo_extra" :label="$t('guides_fees.kilo_extra')"></v-text-field>
                                                </v-col>
                                                <v-spacer></v-spacer>
                                                <!-- <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings.fees[i].insurance" :label="$t('guides_fees.insurance')"></v-text-field>
                                                </v-col> -->
                                            </v-row>

                                            <br>
                                            <v-row class="px-3 py-0 my-0" justify="start" align="center" v-if="i !== 'general_configuration'">
                                                <v-col cols="11" class="py-0 marker1-1 mx-0 px-0">
                                                    <label class="mx-0 px-1" style="font-weight: bolder;">{{ $t('guides_fees.weight_fees') }}</label>
                                                </v-col>
                                                <v-col cols="1" justify="end" align="end" class="px-0 mx-0">
                                                    <v-tooltip bottom v-permission="'relocation.create'">
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn v-on="on" class="right tools-view-height mx-1" color="secondary" outlined @click="open_modal_add_fee(i)" style="max-width: 40px !important; min-width: 40px !important" >
                                                                <v-icon class="material-icons-outlined" small>add</v-icon>
                                                            </v-btn>
                                                        </template>

                                                        <span>{{ $t('guides_fees.add_fee') }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            
                                            <v-row class="px-0 py-0 my-0" justify="start" align="center" v-if="i != 'general_configuration'">
                                                <v-col cols="6" class="py-0" style="display:flex" v-for="(item, j) of Object.entries(settings.fees[i]['shipping_fees'])" :key="j">
                                                    <v-text-field class="py-0" v-model="settings.fees[i]['shipping_fees'][item[0]]" :label="$t('guides_fees.shipping_') + item[0].match(/(\d+)kg_to_(\d+)kg/)[1] + ' KG' + $t('guides_fees.to') + item[0].match(/(\d+)kg_to_(\d+)kg/)[2] + ' KG'"></v-text-field>                                                    
                                                </v-col> 
                                            </v-row>
                                            
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-form>

                    <v-row class="px-5 py-0 mt-2" justify="center" align="center">
                        <v-col cols="10" justify="end" align="end">
                            <v-btn class="right px-3 mx-4" @click="cancel">
                                {{ $t('guides_fees.cancel') }}
                            </v-btn>
                            <v-btn class="right white_highlight--text" color="secondary" @click="saveFees" v-permission="'client.update'">
                                {{ $t('guides_fees.save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>   
        
        <!-- CREATE PICKUP ADDRESS -->
        <v-dialog v-model="modal_create" persistent max-width="90%">
            <v-form ref="picking_addres_form" lazy-validation @submit.prevent="savePA">
                <v-card style="min-width: 650px !important">
                    <v-card-text>
                        <v-row align="center" justify="center" class="pt-3 mt-3 text-center">
                            <v-col cols="12">
                                <h3>{{ $t('guides_fees.new_pickup_address') }}</h3>
                            </v-col>
                        </v-row>
                        <br>
                        <v-row class="px-3 py-0 mt-0 mb-2" justify="center" align="center">
                            <v-col cols="11" class="py-0 marker1-1 mx-0 px-0">
                                <label class="mx-0 px-0">{{ $t('guides_fees.contact') }}</label>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0">
                                <v-text-field class="py-0" v-model="pickup_address.contact.person_name" :rules="rules_required" :label="$t('guides_fees.contact_name')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0">
                                <v-text-field class="py-0" v-model="pickup_address.contact.email" :rules="rules_required" :label="$t('guides_fees.contact_email')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0">
                                <v-text-field class="py-0" v-model="pickup_address.contact.phone_number" :rules="rules_required" :label="$t('guides_fees.contact_phone')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-3 py-0 mt-0 mb-2" justify="center" align="center">
                            <v-col cols="11" class="py-0 marker1-1 mx-0 px-0">
                                <label class="mx-0 px-0">{{ $t('guides_fees.address') }}</label>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0">
                                <v-text-field class="py-0" v-model="pickup_address.address.country" readonly :rules="rules_required" :label="$t('guides_fees.address_country')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0">
                                <v-text-field class="py-0" v-model="pickup_address.address.state" :rules="rules_required" :label="$t('guides_fees.address_state')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0">
                                <v-text-field class="py-0" v-model="pickup_address.address.municipality" :rules="rules_required" :label="$t('guides_fees.address_municipality')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0">
                                <v-text-field class="py-0" v-model="pickup_address.address.neighborhood" :rules="rules_required" :label="$t('guides_fees.address_neighborhood')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0">
                                <v-text-field class="py-0" v-model="pickup_address.address.street" :rules="rules_required" :label="$t('guides_fees.address_street')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0">
                                <v-text-field class="py-0" v-model="pickup_address.address.external_number" :rules="rules_required" :label="$t('guides_fees.address_external_number')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0">
                                <v-text-field class="py-0" v-model="pickup_address.address.internal_number" :label="$t('guides_fees.address_internal_number')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0">
                                <v-text-field class="py-0" v-model="pickup_address.address.postal_code" :rules="rules_required" :label="$t('guides_fees.address_zipcode')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0" align="end" justify="end">
                                <v-btn class="mx-3" text @click="cancelNewPA()">{{ $t('guides_fees.cancel') }}</v-btn>
                                <v-btn color="secondary" class="white_highlight--text" @click="savePA()">
                                    {{ $t('guides_fees.save') }}
                                </v-btn>    
                            </v-col>
                        </v-row>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-form>
        </v-dialog>

        <!-- CREATE SHIPPING SERVICE FEE -->
        <v-dialog v-model="modal_add_fee" persistent max-width="90%">
            <v-form ref="create_fee" lazy-validation @submit.prevent="saveFee">
                <v-card style="min-width: 650px !important">
                    <v-card-text>
                        <v-row align="center" justify="center" class="pt-3 mt-3 text-center">
                            <v-col cols="12">
                                <h3>{{ $t('guides_fees.new_fee_range') }}</h3>
                            </v-col>
                        </v-row>
                        <br>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="5" class="py-0">
                                <v-text-field class="py-0" type="number" v-model="new_fee.min" @keypress="onlyPositiveIntegers" :rules="rules_required" :label="$t('guides_fees.min')"></v-text-field>
                            </v-col>
                            <v-col cols="1" class="py-0">
                                {{ $t('guides_fees.to') }}
                            </v-col>
                            <v-col cols="5" class="py-0">
                                <v-text-field class="py-0" type="number" v-model="new_fee.max" @keypress="onlyPositiveIntegers" :rules="rules_required" :label="$t('guides_fees.max')"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0">
                                <v-text-field class="py-0" v-model="new_fee.value" :rules="rules_required" :label="$t('guides_fees.fee')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0" align="end" justify="end">
                                <v-btn class="mx-3" text @click="cancelNewFee()">{{ $t('guides_fees.cancel') }}</v-btn>
                                <v-btn color="secondary" class="white_highlight--text" @click="saveFee()">
                                    {{ $t('guides_fees.add') }}
                                </v-btn>    
                            </v-col>
                        </v-row>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-form>
        </v-dialog>

        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { createSettingsGuideUseCase } from '../application/use_cases/create_settings_guide_use_case';
import { loadDataSettingsGuideUseCase } from '../application/use_cases/load_data_settings_guide_use_case';
import { HttpSettingsGuideRepository } from '../infrastructure/repositories/settings_guide_repository';
import { indexPickupAddressesUseCase } from '../../pickup_addresses/application/use_cases/index_pickup_addresses_use_case'
import { HttpPickupAddressRepository } from '../../pickup_addresses/infrastructure/pickup_address_repository'
import { createPickupAddressUseCase } from '../../pickup_addresses/application/use_cases/create_pickup_address_use_case';

export default {
    computed: {
        // rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field'), v => /^[1-9]\d*$/.test(v) || this.$t('create_appointment.validations.positive_integer')]},
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('pickup_addresses.address'), align: "center", value: 'address.direction', class: 'text-uppercase' },
                { text: this.$t('pickup_addresses.state'), align: "center", value: 'address.state', class: 'text-uppercase' },
                { text: this.$t('pickup_addresses.city'), align: "center", value: 'address.municipality', class: 'text-uppercase' },
                { text: this.$t('pickup_addresses.neighborhood'), align: "center", value: 'address.neighborhood', class: 'text-uppercase' },
                { text: this.$t('pickup_addresses.zipcode'), align: "center", value: 'address.zipcode', class: 'text-uppercase' },
                // { text: this.$t('pickup_addresses.actions'), align: "center", value: 'actions', class: 'text-uppercase' },
            ];
        } 
    },
    data(){
        return {
            id: this.$route.params.id,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            client_name: "",
            parcel_names: [
                {text: "FEDEX", value: "fedex"}
            ],
            settings: {
                owner: this.$route.params.id,
                fees: { 
                    general_configuration: {
                        monthly_shipping_limit: 0,
                        unpaid_guides_limit: 0
                    },
                    fedex: {
                        shipping_fees: {},
                        address_correction: 0,
                        saturday_pickup: 0,
                        extra_large_package: 0,
                        kilo_extra: 0,
                        insurance: 1
                    }
                }
            },
            props: {
                items: [],
                search: ''
            },
            pickup_address: {
                client_id: this.$route.params.id,
                contact: {
                    person_name: "",
                    email: "",
                    phone_number: ""
                },
                address: {
                    country: "México",
                    state: "",
                    municipality: "",
                    neighborhood: "",
                    street: "",
                    external_number: "",
                    internal_number: "",
                    postal_code: ""
                }
            },
            modal_create: false,
            behaviors: [{ text: this.$t("guides_fees.porcentual"), value: true }, { text: this.$t("guides_fees.fixed"), value: false }],
            modal_add_fee: false,
            shipping_service_to_insert: "",
            new_fee: {
                min: "",
                max: "",
                value: ""
            }
        }
    },
    mounted(){
        this.loadData();
        this.$store.state.module = "headers.guides_fees";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async loadData(){
            try {
                this.settings = await loadDataSettingsGuideUseCase(this.id, HttpSettingsGuideRepository);
                this.props.items = await indexPickupAddressesUseCase(this.id, HttpPickupAddressRepository);
            } catch (e) {
                console.log(e)

                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: 'Error ' + e.message
                }
            }
        },
        async saveFees(){
            try {
                const response = await createSettingsGuideUseCase(this.settings, HttpSettingsGuideRepository);
                response;

                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: this.$t('guides_fees.saved_successfully')
                }
                
                this.$router.go(-1);
            } catch (e) {
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: 'Error ' + e.message
                }
            }
        },
        cancel(){
            this.$router.go(-1);
        },
        cancelNewPA(){
            this.modal_create = false;
        },
        async savePA(){
            const is_valid = this.$refs.picking_addres_form.validate();

            if(!is_valid) return;

            console.log(is_valid)

            try{
                const result = await createPickupAddressUseCase(this.pickup_address, HttpPickupAddressRepository);
                
                result;

                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: this.$t('guides_fees.saved_successfully')
                }

                this.modal_create = false;

                await this.loadData();

                this.$refs.picking_addres_form.reset();
            } catch (e) {
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: 'Error ' + e.message
                }
            }
        },
        open_modal_add_fee(ss){
            this.modal_add_fee = true;
            this.shipping_service_to_insert = ss;
        },
        cancelNewFee(){
            this.modal_add_fee = false
            this.shipping_service_to_insert = "";
            this.$refs.create_fee.reset();
        },
        async saveFee(){
            if(!this.$refs.create_fee.validate()) return;
            const is_valid = this.isValidNewFee();

            if (!is_valid.result) {
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: is_valid.message
                }
                
                return;
            }

            this.settings.fees[this.shipping_service_to_insert]["shipping_fees"]["shipping_" + this.new_fee.min + "kg_to_" + this.new_fee.max +"kg"] = this.new_fee.value;

            console.log(this.settings.fees[this.shipping_service_to_insert]['shipping_fees'])
            this.$refs.create_fee.reset();

            this.modal_add_fee = false
            this.shipping_service_to_insert = "";
        },
        isValidNewFee(){
            const properties = Object.entries(this.settings.fees[this.shipping_service_to_insert]["shipping_fees"]);
            var result = { result: true };

            if(parseInt(this.new_fee.max) <= parseInt(this.new_fee.min)) result = { result: false, message: this.$t('guides_fees.min_max_must_be_different')}

            properties.forEach( x => {
                const range = x[0].match(/(\d+)kg_to_(\d+)kg/);
                
                if(parseInt(this.new_fee.min) > parseInt(range[1]) && parseInt(this.new_fee.min) <= parseInt(range[2])) result =  { result: false, message: this.$t('guides_fees.min_range_invalid')}
                if(parseInt(this.new_fee.max) > parseInt(range[1]) && parseInt(this.new_fee.max) <= parseInt(range[2])) result =  { result: false, message: this.$t('guides_fees.max_range_invalid')}
            })

            return result
        },
        onlyPositiveIntegers(e) {
            const char = String.fromCharCode(e.keyCode)
            if (!/[0-9]/.test(char)) {
                e.preventDefault()
            }
        }
    },
    watch:{
        
    }
}
</script>

<style lang="css">
</style>